// @ts-nocheck
import CalendarLine from "@store/Library/Components/Toolkit/Icons/Calendar/CalendarLine";
// import { buttonFieldIconClickableStyles, buttonFieldIconStyles } from "@store/Themes/common/mixins/button"; // Greif
import { transitionHoverStyles } from "@store/Themes/common/mixins/transition";
import Styleguide from "@toolkit/Framework/Types/Styleguide";
import { css } from "styled-components";

/* Greif Custom Code - Start */
import { buttonFieldIconClickableStyles, buttonFieldIconStyles } from "@store/Themes/common/mixins/button";
/* Greif Custom Code - End */

const datePicker: Styleguide["datePicker"] = {
    formatBasedOnLanguage: true,
    defaultProps: {
        format: "M/d/yyyy", // Date Time: "M/d/yyyy, hh:mm a"
        calendarIconProps: {
            src: CalendarLine,
            color: "inherit",
            css: buttonFieldIconStyles(),
        },
        clearIconProps: {
            color: "inherit",
        },
        cssOverrides: {
            formField: null as any,
            datePicker: css`
                .react-datetime-picker {
                    &__calendar-button {
                        ${buttonFieldIconClickableStyles()}
                    }
                }

                .react-calendar {
                    box-shadow: ${x => x.theme.shadows["2"] /* Greif Custom Code */};

                    button {
                        transition: ${transitionHoverStyles("color", "background-color")};
                    }
                }
            `,
        },
    },
};

export default datePicker;
